<template>
  <block
    component-name="block-text-scream"
    body-class="flex flex-col items-center w-11/12 mx-auto gap-3xl phablet:w-10/12 laptop:w-9/12 desktop:w-8/12"
  >
    <header class="flex flex-col items-stretch w-full gap-xs">
      <wrapper-reveal
        v-if="$attrs.data.body.overline"
        reveal="fade-from-right"
        class="w-full"
      >
        <div
          class="w-full text-overline-big"
          v-html="$attrs.data.body.overline"
        ></div>
      </wrapper-reveal>

      <wrapper-split-text
        v-if="$attrs.data.body.text"
        reveal="chars"
        class="w-full"
      >
        <div class="w-full text-heading-2" v-html="$attrs.data.body.text"></div>
      </wrapper-split-text>
    </header>

    <wrapper-reveal
      v-if="$attrs.data.body.button"
      class="w-full"
      reveal="fade-from-right"
    >
      <btn-pill
        size="big"
        :title="$attrs.data.body.button.title"
        :action="$attrs.data.body.button.action"
      />
    </wrapper-reveal>
  </block>
</template>
